import heroImageSrc from '@images/marketing/Reviews.png';
var reviewsHeroImage = {
    src: heroImageSrc,
    alt: 'An Australian Shepherd looking up expectantly',
};
export var reviewsContent = {
    heroImage: reviewsHeroImage,
    reviews: [
        {
            title: 'Happy Dog, Happy Life',
            quote: 'The variety of dog food options is plentiful and my dog is super happy.',
            author: 'Michelle F.',
            rating: '4.2',
        },
        {
            title: 'It’s Incredible',
            quote: 'Nom Nom is making my kid the best version of himself.',
            author: 'Chris S.',
            rating: '4.2',
        },
        {
            title: 'Trooper LOVES This Food',
            quote: 'He used to be picky and now he’s joyful as we prepare his meal.',
            author: 'Robert I.',
            rating: '4.2',
        },
        {
            title: 'Exceptional Dog Food',
            quote: 'You can see the quality and the ingredient list is short. A superior product.',
            author: 'Cassie M.',
            rating: '4.2',
        },
        {
            title: 'Great Customer Support',
            quote: 'Suggestions for my dog’s specific needs have worked well.',
            author: 'Pip’s Mom',
            rating: '4.2',
        },
    ],
};
export var treatsPLPReviewsContent = {
    heroImage: reviewsHeroImage,
    reviews: [
        {
            title: 'My Pups Love It',
            quote: 'Their very favorite treats. They make them smile.',
            author: 'Alex D.',
            rating: '4.2',
        },
        {
            title: 'Finally, a Dog Treat With One Ingredient',
            quote: 'It’s so nice to know exactly what I’m feeding her.',
            author: 'DA F.',
            rating: '4.2',
        },
        {
            title: 'Actually Licks His Lips',
            quote: 'My picky eater comes in the kitchen whenever I even open a bag that sounds similar.',
            author: 'PJ',
            rating: '4.2',
        },
        {
            title: 'A Healthy Product for Dogs',
            quote: 'She stands up on her hind legs to ask for them.',
            author: 'Dani P.',
            rating: '4.2',
        },
    ],
};
export var probioticsPLPReviewsContent = {
    heroImage: reviewsHeroImage,
    reviews: [
        {
            title: 'Works Great',
            quote: 'Rarely leave reviews, but this has been wonderful for my Great Dane. So glad to have found this product.',
            author: 'Nikki P.',
            rating: '4.2',
        },
        {
            title: 'Improves My Dog’s Well-Being',
            quote: 'I use it daily to support my dog’s healthy stomach and bowel functions.',
            author: 'Bonnie B.',
            rating: '4.2',
        },
        {
            title: 'Great for Doggie Digestion',
            quote: 'Makes a big difference. Has kept my dog’s stools gentle.',
            author: 'AJ L.',
            rating: '4.2',
        },
        {
            title: 'Really Works',
            quote: 'My dog loves it AND it works great for him!',
            author: 'Michelle L.',
            rating: '4.2',
        },
    ],
};
